import React from 'react'
import './newsletter-subscribe.css'

const NewsletterSubscribe = () => {
  return (
    <section className="newsletter-container thq-section-padding">
      <div className="newsletter-content thq-section-max-width">
        <h2 className="newsletter-heading">
          Subscribe unseren Newsletter
        </h2>

        <form className="newsletter-form">
          <input
            type="email"
            required
            placeholder="Ihre E-Mail-Adresse"
            className="newsletter-input"
          />
          <button type="submit" className="btn btn-primary">
            Abonnieren
          </button>
        </form>
      </div>
    </section>
  )
}

export default NewsletterSubscribe
